import { browserName } from "@src/utils/browser";
import { dispatchEventToNative } from "@src/utils/dispatchEventToNative";
import { isNativeApp } from "@src/utils/isNativeApp";

const INTERNAL_HOSTS = ["fabricca.pro", "meuplay.fabriccamultimidia.com"];

/**
 * Em wrapper nativo (Electron ou React Native), cliques em `<a target="_blank">`:
 * host interno navega no próprio window (como _self); host externo abre no
 * navegador do SO (via open_external). No navegador comum, no-op.
 */
export function setupNativeLinks() {
  if (browserName !== "Electron" && !isNativeApp) return;

  document.addEventListener(
    "click",
    (event) => {
      if (!(event.target instanceof Element)) return;
      const anchor = event.target.closest('a[target="_blank"]');
      if (!(anchor instanceof HTMLAnchorElement) || !anchor.href) return;

      let host: string;
      try {
        host = new URL(anchor.href).hostname;
      } catch {
        return;
      }

      event.preventDefault();
      if (INTERNAL_HOSTS.includes(host)) {
        window.location.href = anchor.href;
      } else {
        dispatchEventToNative("open_external", { url: anchor.href });
      }
    },
    true,
  );
}
